import { type FC, type PropsWithChildren, useRef } from 'react';

// import { useBlurHeader } from '@/common/hooks/blur-header';
import Header from '@/components/Header/Header';
import BurgerSettingsModal from '@/components/Modals/BurgerSettingsModal/BurgerSettingsModal';

import { ToastWrapper } from '../ToastWrapper/ToastWrapper';
import { ToolBar } from '../ToolBar/ToolBar';

const MainContainer: FC<PropsWithChildren> = ({ children }) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  // useBlurHeader(scrollContainerRef);

  return (
    <div
      ref={scrollContainerRef}
      style={{
        height: `calc(${window.innerHeight}px - var(--tabbar-height) - var(--tg-safe-area-inset-bottom,0px))`,
        overflowY: 'auto',
        // room for the floating tab bar of the native app
        paddingBottom: 'var(--tabbar-overlay, 0px)',
      }}
      className="w-full overflow-hidden hidden-scrollbar "
    >
      {/* <PullToRefreshWrapper> */}
      <Header />
      <ToolBar />
      <BurgerSettingsModal />
      <ToastWrapper />
      {children}
      {/* </PullToRefreshWrapper> */}
    </div>
  );
};

export { MainContainer };
